export default __webpack_public_path__ + "static/pointTwo-43e238b7402a21c039a8063dc5b1c7c2.png";